// extracted by mini-css-extract-plugin
module.exports = {"list":"_1p57zyDsOiuNSmR9h0Ksxg==","listItem":"_2neLYRp8QpZOuGMjO7ZDJw==","fileSize":"gRzCqoT7OlbD9L35p5vjTQ==","deleteIcon":"MKejrBjvcRNPtwGfNJV6pA=="};